function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#102E8E",
  fillRule: "evenodd",
  d: "M4.22 1.107l-3.3 4.4a.6.6 0 00.48.96H8a.6.6 0 00.48-.96l-3.3-4.4a.6.6 0 00-.96 0z"
});

var SvgImgTriangle1 = function SvgImgTriangle1(props) {
  return React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5IiBoZWlnaHQ9IjciIHZpZXdCb3g9IjAgMCA5IDciPgogIDxwYXRoIGZpbGw9IiMxMDJFOEUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTQuMjIwMDQ3MDgsMS4xMDY3MTM3NSBMMC45MjAwNDcwODEsNS41MDY3MTM3NSBDMC43MjEyMjQ1NzEsNS43NzE4MTA0MyAwLjc3NDk1MDQwMSw2LjE0Nzg5MTI0IDEuMDQwMDQ3MDgsNi4zNDY3MTM3NSBDMS4xNDM5MDQ3OCw2LjQyNDYwNzAyIDEuMjcwMjI0OTUsNi40NjY3MTM3NSAxLjQwMDA0NzA4LDYuNDY2NzEzNzUgTDguMDAwMDQ3MDgsNi40NjY3MTM3NSBDOC4zMzE0MTc5Myw2LjQ2NjcxMzc1IDguNjAwMDQ3MDgsNi4xOTgwODQ2IDguNjAwMDQ3MDgsNS44NjY3MTM3NSBDOC42MDAwNDcwOCw1LjczNjg5MTYyIDguNTU3OTQwMzYsNS42MTA1NzE0NSA4LjQ4MDA0NzA4LDUuNTA2NzEzNzUgTDUuMTgwMDQ3MDgsMS4xMDY3MTM3NSBDNC45ODEyMjQ1NywwLjg0MTYxNzA2OCA0LjYwNTE0Mzc2LDAuNzg3ODkxMjM4IDQuMzQwMDQ3MDgsMC45ODY3MTM3NDggQzQuMjk0NTYzNjgsMS4wMjA4MjYzIDQuMjU0MTU5NjMsMS4wNjEyMzAzNSA0LjIyMDA0NzA4LDEuMTA2NzEzNzUgWiIvPgo8L3N2Zz4K";
export { SvgImgTriangle1 as ReactComponent };